module.exports = __webpack_public_path__ + "img/login-side-image.2dd9e103.png";